import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { baseUrl } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HotnumberService {
  constructor(private http: HttpClient) {}

  Add(data: any) {
    return this.http.post(`${baseUrl}hotnumbers/add`, data);
  }

  getData(): Observable<any> {
    return this.http.get(`${baseUrl}hotnumbers/getdata`);
  }

  Delete(data: any) {
    return this.http.post(`${baseUrl}hotnumbers/delete`, data);
  }
}
